// extracted by mini-css-extract-plugin
export var center = "_1x-2";
export var clickableRow = "_1x-5";
export var expandedRow = "_1x-7";
export var hoverable = "_1x-4";
export var left = "_1x-1";
export var right = "_1x-3";
export var row = "_1x-0";
export var selectedRow = "_1x-6";
export var summaryRow = "_1x-8";